import {API, Entities} from "../../utils/Api";
import {CenterHero, TicketHero} from "../../blocks/hero/Hero";
import {DetailedEvents} from "../../blocks/events/Events";
import {PrimaryButton} from "../../components/button/Button";
import {Footer} from "../../blocks/footer/Footer";
import {useLoaderData, useRouteLoaderData} from "react-router-dom";
import {ExhibitorsGrid} from "../../blocks/grid/Grid";
import {EventsLoader} from "../events/EventsPage";
import {ExhibitorsLoader} from "../exhibitors/ExhibitorsPage";

export default function EventInfoPage(){
    const data = useLoaderData();
    var events = data.events;
    var invidualEvents=events.filter((event)=>{return event.presenters.length===1});
    var teamEvents=events.filter((event)=>{return event.presenters.length>1});
    var eventsByCategory= [
        {title:'Egyéni előadók', presentations: invidualEvents},
        {title: 'Panelbeszélgetések', presentations: teamEvents}
    ]

    var exhibitors = data.exhibitors;
    var filters=[];
    return(
        <>
        <DetailedEvents title={"Program"} description={'Alább tájékozódhatsz az előadókról és a programokról'} events={eventsByCategory}></DetailedEvents>
        <section>
            <div className="container">
                <div className="row justify-content-center mb-3 lg-mb-50px sm-mb-30px">
                    <div className="col-xl-6 text-center">
                        <h2 className="alt-font fw-700 ls-minus-2px text-dark-gray mb-15px">Menü</h2>
                    </div>
                </div>
                <div className="row g-0 mb-5 sm-mb-30px">

                    <div className="col event-style-03 bg-white box-shadow-quadruple-large">
                        <div className="tab-content ps-65px pe-65px pt-45px pb-45px sm-p-30px xs-p-20px">
            <h6>Kezdő fogások:</h6>
            <ul>
                <li>Hideg kacsasült friss kapros túróval</li>
                <li>Füstölt sonkatál zöldségekkel, tormás majonézzel</li>
                <li>Pisztráng narancsos paszternákkal, madársalátával</li>
                <li>Rántott camembert áfonyás levelekkel</li>
            </ul>
            <h6>Saláták</h6>
            <ul>
                <li>Joghurtos céklasaláta</li>
                <li>Rukkola saláta, aszalt paradicsommal, fetás jalapeno paprikával</li>
            </ul>
            <h6>Leves</h6>
            <ul>
                <li>Húsleves gazdagon</li>
                <li>Zöldborsó püréleves (vegán) bacon-nel</li>
            </ul>
            <h6>Főfogások</h6>
            <ul>
                <li>Marhapörkölt juhtúrós galuskával</li>
                <li>BBQ tarja steak burgonyával, párolt ceruzababbal</li>
                <li>Grillezett csirkemell cheddar-os risotto-val</li>
                <li>Fogas ropogós kukoricabundában, sült zöldségekkel</li>
                <li>Bulgurral töltött padlizsán <i>(vegán)</i></li>
            </ul>
            <h6>Desszertek</h6>
            <ul>
                <li>Akadémia Klub csokoládétorta</li>
                <li>Rákóczi túrós pohárkrém</li>
                <li>Házi rétesválogatás (meggyes, almás)</li>
                <li>Szezonális, friss gyümölcsök</li>
                <li>Espresso tejjel vagy tejszínnel</li>
            </ul>
            <small><i>A menü tartalmaz vegetáriánus, glutén- és laktózmentes ételeket is; az egyes ételek összetevőit a
                helyszínen kihelyezett
                kártyák jelzik.</i></small>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div className="row justify-content-center mb-3 lg-mb-50px sm-mb-30px">
                <div className="col-xl-6 text-center">
                    <h2 className="alt-font fw-700 ls-minus-2px text-dark-gray mb-15px">Kiállítók</h2>
                </div>
            </div>
        <ExhibitorsGrid filters={filters} exhibitors={exhibitors}></ExhibitorsGrid>
        </section>
        <a href={'https://www.benefitprize.hu'}><img src={'/benefitshare/img/BF_PRIZE_banner.jpg'} style={{width:"100vw"}}></img></a>
        </>
    );

}

export async function EventInfoLoader(){
var response_ev=await EventsLoader();
var response_ex= await ExhibitorsLoader();
return({events:response_ev.events,exhibitors:response_ex.exhibitors});
}